import carouselImages from './components/sliders/carousel_images';
import videoFrame from './components/video';

carouselImages.init();
videoFrame.init();